import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=1484d7e3&"
import script from "./MessageTemplates.vue?vue&type=script&lang=js&"
export * from "./MessageTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=1484d7e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports